import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import mailForm from './mailForm.vue';
import messageForm from './messageForm.vue';
import emailForm from './emailForm.vue';
import { sceneConfigList } from '../request';
export default {
  props: {
    sceneListId: {
      type: String | Number,
      default: ''
    },
    variables: {
      type: Object,
      default: () => {}
    },
    tabKey: {
      type: String,
      default: ''
    },
    allMessageList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    mailForm,
    messageForm,
    emailForm
  },
  data() {
    return {
      collapses: [{
        title: '简体中文',
        key: 'ZH'
      }, {
        title: '繁体中文',
        key: 'CHT'
      }, {
        title: '英语',
        key: 'EN'
      }, {
        title: '法语',
        key: 'FRA'
      }, {
        title: '西班牙语',
        key: 'SPA'
      }],
      datas: {},
      type: 'INTERNAL_MAIL',
      activeKey: []
    };
  },
  created() {
    this.getSceneConfigList();
  },
  watch: {
    tabKey: {
      handler(val) {
        if (val) {
          this.activeKey = [];
        }
      }
    }
  },
  mounted() {},
  methods: {
    collapseChange(keys) {
      if (keys.length > 0) {
        let currentSaved = false;
        if (this.activeKey.length > 0) {
          //判断当前是否保存 保存了才能切换
          let currentOpenCollapse = this.$refs[`${this.tabKey}${this.activeKey[0]}`];
          currentSaved = currentOpenCollapse.length > 0 ? currentOpenCollapse[0].btnShow === 3 && currentOpenCollapse[0].isEdit === true : false;
        }
        if (currentSaved) {
          this.$message.error(this.$t('请先保存当前面板配置'));
          this.activeKey = [...this.activeKey];
        } else {
          let keyNew = keys[keys.length - 1];
          this.activeKey = [keyNew];
        }
      } else {
        this.activeKey = [];
      }
    },
    getSceneConfigList() {
      let params = {
        sceneListId: this.sceneListId,
        type: this.tabKey
      };
      sceneConfigList(params).then(res => {
        if (res) {
          res.forEach(element => {
            this.$set(this.datas, element.language, element);
          });
        }
      });
    }
  }
};